import { MunicipalPropertyHistoryQuery } from "@/graphql/generated/graphql";
import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { queryKeys } from "@/services/react-query.service/query-keys";
import { DEFAULT_STALE_TIME_MS } from "@/services/react-query.service/stale-time";
import { useQuery, UseQueryResult } from "@tanstack/react-query";

import { MUNICIPAL_PROPERTY_HISTORY_QUERY_DOCUMENT } from "./municipal-property-history-query.gql";

export function useMunicipalPropertyHistory({
  propertyId,
  year,
}: {
  propertyId: string;
  year: number;
}): UseQueryResult<MunicipalPropertyHistoryQuery["municipalPropertyHistory"], Error> {
  return useQuery({
    queryKey: queryKeys.municipalProperties.history({ propertyId, year }),
    queryFn: async (): Promise<MunicipalPropertyHistoryQuery["municipalPropertyHistory"]> => {
      const response: MunicipalPropertyHistoryQuery = await createOperationClient("MunicipalPropertyHistory").request(
        MUNICIPAL_PROPERTY_HISTORY_QUERY_DOCUMENT,
        { input: { id: propertyId, year } },
      );
      return response.municipalPropertyHistory;
    },
    staleTime: DEFAULT_STALE_TIME_MS,
    placeholderData: (previousData) => (previousData?.property?.id === propertyId ? previousData : undefined),
  });
}
